import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({ onOpenModal }) => {
  const jurisdictions = [
    { name: 'Mainland', link: '#mainland' },
    { name: 'Free Zone', link: '#freezone' },
    { name: 'Offshore', link: '#offshore' },
    { name: 'KSA', link: '#ksa' },
  ];

  return (
    <section 
      className="relative h-screen flex items-center justify-start"
      style={{
        backgroundImage: 'linear-gradient(rgba(20, 10, 30, 0.7), rgba(20, 10, 30, 0.7)), url(https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="container mx-auto px-4 z-10">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Business Setup<br />
            <span className="text-white">Is Just The Beginning</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-white mb-8">
            UAE Expansion, Hassle-Free
          </p>
          
          <div className="flex flex-wrap gap-4 mb-8 text-white text-lg">
            {jurisdictions.map((item, idx) => (
              <React.Fragment key={idx}>
                <a 
                  href={item.link} 
                  className="hover:text-[#DC143C] transition-colors"
                >
                  {item.name}
                </a>
                {idx < jurisdictions.length - 1 && <span className="text-gray-400">|</span>}
              </React.Fragment>
            ))}
          </div>

          <Button 
            size="lg" 
            className="bg-[#6B1B4D] hover:bg-[#8B1B5D] text-white px-8 py-6 text-lg rounded-md shadow-lg hover:shadow-xl transition-all duration-300 group"
            onClick={onOpenModal}
          >
            START NOW
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;